import { get, isEmpty, omit } from 'lodash';
import { AssociationQuery } from 'v4/entities/associations/resource__shortlist/resource__shortlist.schemas';
import { NestedPath } from 'v4/entities/common/Path';

const removeIfEmpty = <T extends Record<string, unknown>>(
  obj: T,
  key: NestedPath<T>
) => {
  if (isEmpty(get(obj, key))) {
    return omit(obj, key) as T; // we lie here a bit, otherwise we should create a generic that will remove nested keys
  }
  return obj;
};
const normalizeAssociationQuery = (query: AssociationQuery | undefined) => {
  let q = query;
  if (!q) {
    return q;
  }
  // For resource_id queries, remove the query property entirely since it's not used
  if ('resource_id' in q) {
    return { resource_id: q.resource_id };
  }
  // For shortlist_id queries, normalize the query
  q = removeIfEmpty(q, 'query.filters');
  q = removeIfEmpty(q, 'query.sort');
  q = removeIfEmpty(q, 'query.search');
  q = removeIfEmpty(q, 'query');
  return q;
};
export const resourceShortlistKeys = {
  all: () => ['resource_shortlist'] as const,
  lists: () => [...resourceShortlistKeys.all(), 'lists'] as const,
  list: (query: AssociationQuery | undefined) => {
    return [
      ...resourceShortlistKeys.lists(),
      normalizeAssociationQuery(query)
    ] as const;
  }
};
